// context/UserContext.js

import axios from "axios";
import { createContext, useContext, useState } from "react";

const UserContext = createContext();
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  /* ================= GET PROFILE ================= */
  const fetchUserProfile = async () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("authUser"));
      const token = storedUser?.token;

      const res = await axios.get(`${BASE_URL}/api/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUser(res.data);
      return res.data;
    } catch (err) {
      console.error("Fetch profile failed", err);
    }
  };

  /* ================= UPDATE PROFILE ================= */
  const updateUser = async (payload) => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("authUser"));
      const token = storedUser?.token;

      const res = await axios.put(`${BASE_URL}/api/update`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUser(res.data.data);
      return res.data.data;
    } catch (err) {
      console.error("Update failed", err);
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        fetchUserProfile,
        updateUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
